import React from 'react';
import {DebounceInput} from 'react-debounce-input';

interface IProps {
    label: string,
    error: string,
    placeholder: string,
    value: string,
    handleChange(source): void
    handleBlur(): void;
    onKeyPress?(event: React.KeyboardEvent<HTMLInputElement>): void;
    disabled?: boolean
}
const TextInput: React.FC<IProps> = (props): JSX.Element => {
    return (
        <div className="flex flex-col my-2">
            <div className="text-xs uppercase font-bold mb-2">{props.label}</div>
            <div
                className={`flex h-10 px-2 py-1 border border-gray rounded-md${props.error ? ' border-red' : ''}${props.value !== undefined && props.value !== '' ? ' border-blue': ''}`}
                >
                    <DebounceInput
                        className="w-full border-none outline-none p-0 disabled:opacity-80 text-sm"
                        value={props.value && props.value}
                        onKeyPress={event => typeof props.onKeyPress !== 'undefined' ? props.onKeyPress(event) : null}
                        onChange={event => props.handleChange(event.target.value)}
                        placeholder={props.placeholder || ''}
                        onBlur={props.handleBlur}
                        disabled={typeof props.disabled !== 'undefined' ? props.disabled : false}
                    />
            </div>
            {props.error && (
                <div className="text-red">{props.error}</div>
            )}
        </div>
    );
};

export default TextInput;
